import { useQuery } from '@ltvco/refresh-lib/vendors';

import { DEFAULT_QUERY_OPTIONS, useBaseCourtApi } from './useBaseCourtApi';

export const useCourtCaseDetails = (id: string | undefined) => {
  const { getDocket, getCourt, isLoading: isTokenLoading } = useBaseCourtApi();

  const docketQuery = useQuery(
    ['docket', id],
    () => (id ? getDocket(id) : null),
    {
      ...DEFAULT_QUERY_OPTIONS,
      enabled: !!id && !isTokenLoading,
    }
  );

  const courtQuery = useQuery(
    ['court', docketQuery.data?.court_id],
    () =>
      docketQuery.data?.court_id ? getCourt(docketQuery.data.court_id) : null,
    {
      ...DEFAULT_QUERY_OPTIONS,
      enabled: !!docketQuery.data?.court_id && !isTokenLoading,
    }
  );

  return {
    docketQuery,
    courtQuery,
    isLoading: docketQuery.isLoading || isTokenLoading,
    isError: docketQuery.isError,
    error: docketQuery.error,
    data: docketQuery.data,
  };
};
